// @flow
import type { Media } from 'types/media';
import type { FSA } from 'types/redux';
import _ from 'lodash';
import * as RequestResultCases from 'middlewares/api-middleware';
import { UPLOAD_MEDIUM, REPLACE_MEDIUM, DOWNLOAD_FILE, GET_MEDIUM } from 'actions/media';

export type MediaState = {
  newlyCreatedObject: ?Media,
  requestSource: string,
  files: Object,
  mediumHash: Object,
};

export const defaultMediaState = {
  newlyCreatedObject: null,
  requestSource: '',
  files: {},
  mediumHash: {},
};

const media = (state: Object = defaultMediaState, action: FSA): MediaState => {
  switch (action.type) {
    case UPLOAD_MEDIUM + RequestResultCases.SUCCESS:
      return {
        ...state,
        newlyCreatedObject: action.payload,
        requestSource: action.meta ? action.meta.requestSource : '',
      };
    case REPLACE_MEDIUM + RequestResultCases.SUCCESS:
      return {
        ...state,
        newlyCreatedObject: action.payload,
        requestSource: action.meta ? action.meta.requestSource : '',
      };
    case DOWNLOAD_FILE + RequestResultCases.SUCCESS:
      return {
        ...state,
        files: { ...state.files, [_.get(action, 'meta.request.url')]: action.payload },
      };
    case GET_MEDIUM + RequestResultCases.SUCCESS: {
      const { mediumID } = action.payload;
      return {
        ...state,
        mediumHash: {
          ...state.mediumHash,
          [mediumID]: action.payload,
        },
        requestSource: action.meta ? action.meta.requestSource : '',
      };
    }
    default:
      return state;
  }
};

export default media;
